import { ModuleNameToModuleRegistry } from '../../types/types';
import { BenchmarksSignInListCard } from './components/BenchmarksSignInListCard';
import { EnterpriseSignInListCard } from './components/EnterpriseSignInListCard';

const signInListCards: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  sign_in_benchmarks: BenchmarksSignInListCard,
  sign_in_enterprise: EnterpriseSignInListCard,
});

export default signInListCards;
